var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 205,
    viewBox: "0 0 206 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4880_644624)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4880_644624)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.0492,
    cy: 41.5156,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.976,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.456,
    cy: 68.2462,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.069,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.307,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.566 100.347C167.566 137.155 137.461 167.009 100.307 167.009C63.1535 167.009 33.0492 137.155 33.0492 100.347C33.0492 63.539 63.1535 33.6853 100.307 33.6853C137.461 33.6853 167.566 63.539 167.566 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61465,
    cy: 69.6784,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.1663,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.6702,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.95,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 123.697,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 128.47,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 109.854,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 174.294,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 189.568,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 180.26,
    cy: 123.617,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 184.079,
    cy: 93.5446,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 191.955,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 186.466,
    cy: 40.7996,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 73.8158,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 39.6865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.4599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 13.4332,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.3545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2.69345,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 21.5481,
    cy: 64.6665,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 25.3665,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 61.8823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 108.422,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.437,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 150.347C169.421 150.347 168.566 149.493 168.566 148.438C168.566 147.384 169.421 146.529 170.475 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51196 117.65C7.56645 117.65 8.42129 116.795 8.42129 115.741C8.42129 114.686 7.56645 113.831 6.51196 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5315 22.4228C75.586 22.4228 76.4408 21.5679 76.4408 20.5134C76.4408 19.459 75.586 18.6041 74.5315 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.833 15.7399C119.778 15.7399 118.923 16.5948 118.923 17.6493C118.923 18.7038 119.778 19.5586 120.833 19.5586",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3306 166.934H16.2972M26.3211 155.836V157.388M38.0157 166.934H39.5671M26.3211 176.481V178.271M26.3211 180.658V186.982M21.9058 166.934C24.8892 166.934 26.4405 162.638 26.4405 162.638C26.4405 162.638 26.9178 166.934 30.7365 166.934C29.0181 166.934 26.5598 168.486 26.3211 171.588C26.3211 171.588 26.0432 169.048 25.1278 168.128C24.3635 167.359 21.9058 166.934 21.9058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.709 30.0597L172.742 30.0597M162.599 45.8116L162.719 39.6063M151.024 30.0597L149.473 30.0597M162.599 20.7518L162.599 8.57985M167.134 30.0597C164.151 30.0597 162.599 34.3557 162.599 34.3557C162.599 34.3557 162.122 30.0597 158.303 30.0597C160.022 30.0597 162.48 28.5084 162.719 25.4057C162.719 25.4057 162.996 27.9459 163.912 28.8664C164.676 29.635 167.134 30.0597 167.134 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.8677,
    y: 33,
    width: 90.265,
    height: 125,
    rx: 7,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2948 43.4274C61.2948 40.6659 63.5334 38.4274 66.2948 38.4274H135.705C138.466 38.4274 140.705 40.6659 140.705 43.4274V76.5898H61.2948V43.4274Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.2948,
    y: 76.4189,
    width: 79.4103,
    height: 38.1624,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2948 114.41H140.705V147.573C140.705 150.334 138.466 152.573 135.705 152.573H66.2948C63.5334 152.573 61.2948 150.334 61.2948 147.573V114.41Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1456 54.7949V56.765C90.1456 58.9741 91.9365 60.765 94.1456 60.765H107.312C109.521 60.765 111.312 58.9741 111.312 56.765V54.7949",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1456 92.7864V94.7565C90.1456 96.9656 91.9365 98.7565 94.1456 98.7565H107.312C109.521 98.7565 111.312 96.9656 111.312 94.7565V92.7864",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1456 130.778V132.748C90.1456 134.957 91.9365 136.748 94.1456 136.748H107.312C109.521 136.748 111.312 134.957 111.312 132.748V130.778",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.081 48.8248H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.082 52.8247H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.082 95.8247H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.081 86.8162H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.081 91.1581H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.081 129.15H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.081 124.808H131.936",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4880_644624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4880_644624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesZeroState);
export default __webpack_public_path__ + "static/media/files-zero-state.e167d6abd89109ccacf2e26919b70064.svg";
export { ForwardRef as ReactComponent };